import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Location.svg",
  "use": "Location.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Location.svg\"><path d=\"M33.5962,54.7738a2.1286,2.1286,0,0,1-4.0292-.506L26.7839,38.96A2.1283,2.1283,0,0,0,25.07,37.2469L9.7631,34.4637a2.1285,2.1285,0,0,1-.506-4.0291l39.7242-18.207a2.1286,2.1286,0,0,1,2.8219,2.8219Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol